const CLOUDINARY_CLOUD_NAME = "peerspace-inc";
const CLOUDINARY_UPLOAD_PRESET = "e6m9x7iz";

/** Where Cloudinary serves this cloud's uploaded images (and PDFs). */
const CLOUDINARY_IMAGE_UPLOAD_PREFIX = `https://res.cloudinary.com/${CLOUDINARY_CLOUD_NAME}/image/upload/`;

/** Cloudinary formats accepted for a menu; guests see PDFs in a viewer. */
const MENU_ALLOWED_FORMATS = ["jpg", "jpeg", "png", "pdf"];

/** 10MB, the largest menu file the upload widget accepts. */
const MENU_MAX_FILE_SIZE = 10_000_000;

export {
  CLOUDINARY_CLOUD_NAME,
  CLOUDINARY_IMAGE_UPLOAD_PREFIX,
  CLOUDINARY_UPLOAD_PRESET,
  MENU_ALLOWED_FORMATS,
  MENU_MAX_FILE_SIZE,
};
